export default __webpack_public_path__ + "static/media/pending-icon.0f8a52cb.svg";